import type { CompanyContent } from "./company";

export const defaultCompanyContent: CompanyContent = {
  meta: {
    title: "About Quintara",
    description:
      "Quintara is a Dubai-registered company formed by Numbase Group and JGroup to bring WhatsApp business messaging to enterprises, governments, agencies, operators and SMBs.",
  },
  hero: {
    eyebrow: "Company",
    heading: "Two groups, one focus: business messaging on WhatsApp.",
    lede: "Quintara was formed by Numbase Group and JGroup to bring the infrastructure, the demand and the onboarding together in one company. Numbase brings the rails. JGroup brings the market.",
  },
  consortium: {
    partners: [
      {
        role: "Telecom and AI infrastructure",
        name: "Numbase Group",
        description:
          "A digital innovation group powering mobile operators, governments and enterprises with carrier-grade, AI-driven communication.",
        bullets: [
          "Integrated with 130+ mobile operators, with VAS and carrier billing built in",
          "AI products across messaging, fintech, government and more",
          "Regulatory and public-sector relationships in key growth markets",
        ],
        linkLabel: "Visit numbase.com",
        linkHref: "https://numbase.com",
      },
      {
        role: "Media, data and agency distribution",
        name: "JGroup",
        description:
          "A marketing and media group that represents leading global ad platforms across 35 countries and works with the agencies that move brand budgets.",
        bullets: [
          "Relationships with all six global holding groups and 200+ independent agencies",
          "15,000+ campaigns delivered and 50+ industry awards",
          "Data and AI marketing technology, including FoxPush and the Just Ad API",
        ],
        linkLabel: "Visit jgroup-me.com",
        linkHref: "https://jgroup-me.com",
      },
    ],
  },
  independence: {
    eyebrow: "Independence by design",
    heading: "A dedicated team, separate systems.",
    lede: "Our groups represent several platforms. Quintara is kept apart so that clients and partners can trust how their data is handled.",
    checks: [
      { boldLead: "Dedicated WhatsApp team.", text: "Sales and solutions staff who work only on WhatsApp business messaging." },
      { boldLead: "Separate teams and systems.", text: "No shared pipelines and no cross-platform access to client or campaign data." },
      { boldLead: "Local data residency.", text: "Client and messaging data stays in the market it belongs to, under local rules." },
      { boldLead: "Contractual firewalls.", text: "Data from one platform is never visible to, or used for, another." },
    ],
  },
  whereWeOperate: {
    eyebrow: "Where we operate",
    heading: "Local teams in 35 countries.",
    lede: "The Middle East and North Africa are the core of the business. Dubai is our headquarters, with on-the-ground teams across our groups' footprint.",
    regions: [
      { name: "Gulf", places: "UAE · Saudi Arabia · Qatar · Bahrain · Oman · Kuwait" },
      { name: "Levant and Mediterranean", places: "Lebanon · Iraq · Cyprus · Turkey" },
      {
        name: "Africa",
        places: "Tunisia · Algeria · Morocco · Egypt · Senegal · Ivory Coast · Liberia · Nigeria · Cameroon · DR Congo · Angola · Ethiopia",
      },
      { name: "Asia", places: "Malaysia · Maldives · Pakistan · Bangladesh · Indonesia" },
      { name: "Europe and Americas", places: "UK · USA · Poland · Croatia · Romania · Switzerland · Bulgaria · Serbia" },
    ],
  },
  ctaBand: {
    eyebrow: "Get in touch",
    heading: "Partner with Quintara.",
    lede: "Whether you're a brand, an agency, an operator or a government entity, we'd like to hear what you're planning.",
    buttonLabel: "Talk to our team",
    buttonTo: "/contact",
  },
};
